import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  ActiveInactiveTestimonial,
  deleteTestimonial,
  getAllTestimonial,
} from "./services/testimonial.services";
import { clearTestimonialID, setTestimonialID } from "./testimonialSlice";
import ButtonCreate from "../../components/muidrawer/ButtonCreate";
import ButtonEdit from "../../components/muidrawer/ButtonEdit";
import { Tooltip } from "@mui/material";
import { FaGraduationCap } from "react-icons/fa6";

const Testimonial: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/testimonial/create");
  // };

  useEffect(() => {
    dispatch(getAllTestimonial());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteTestimonialDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Testimonial List
          </Typography.h4>
          {isAddAccess && (
            // <Button
            //   onClick={handleCreate}
            //   fillMode={"solid"}
            //   themeColor={"primary"}
            // >
            //   {"Create Testimonial"}
            // </Button>
            <ButtonCreate
              label="Create Testimonial"
              drawerName="testimonialForm"
              drawerWidth={"50%"}
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <TestimonialGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const TestimonialGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const TestimonialList = useAppSelector(
    (state) => state.testimonial.TestimonialList
  );
  const loading = useAppSelector((state) => state.testimonial.loading);

  useEffect(() => {
    dispatch(getAllTestimonial());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [expandedRow, setExpandedRow] = useState(null);
  const truncateDescription = (Description: string) => {
    if (!Description) return "";
    const maxLength = 100;
    if (Description.length <= maxLength) return Description;
    return Description.substring(0, maxLength) + "...";
  };

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? TestimonialList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    // const handleEdit = (ID: number) => {
    //   navigate("/testimonial/edit", { state: { TestimonialID: ID } });
    // };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteTestimonial"));
      dispatch(setTestimonialID(ID));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          // <IconButton
          //   type="button"
          //   fillMode="flat"
          //   size="small"
          //   title="Edit"
          //   onClick={() => handleEdit(props.dataItem.ID)}
          // >
          //   <FiEdit
          //     className="absolute-position"
          //     style={{ fontSize: "20px" }}
          //   />
          // </IconButton>
          <ButtonEdit
            ID={props.dataItem.ID}
            name="testimonialForm"
            tooltipTitle="Edit"
            drawerWidth={"50%"}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 6 || props.index === 5 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveTestimonial(data)).then((response: any) => {
        // dispatch(getAllTestimonial());
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllTestimonial());
        } else {
          dispatch(getAllTestimonial());
        }
      });
    };

    return (
      <td
        style={{ textAlign: "center", ...props.style }}
        className={props.className}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {TestimonialList && TestimonialList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          className="responsive-table"
          data={
            filter
              ? filterBy(TestimonialList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : TestimonialList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={TestimonialList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="CustomerName"
            title="Customer Name"
            width={200}
            cell={(props: any) => (
              <td>
                <div className="hoverableName">
                  {isEditAccess ? (
                    <ButtonEdit
                      ID={props.dataItem.ID}
                      name="testimonialForm"
                      label={props.dataItem?.CustomerName}
                      drawerWidth={"50%"}
                    />
                  ) : (
                    <div className="normalName">
                      {props.dataItem?.CustomerName}
                    </div>
                  )}
                </div>
              </td>
            )}
          />
          <Column field="UniversityName" title="University" width={200} />
          <Column
            field="Description"
            title="Description"
            width={300}
            cell={(props: any) => (
              <td>
                <div
                  className="remarks-content"
                  dangerouslySetInnerHTML={{
                    __html:
                      expandedRow === props.dataItem?.ID
                        ? props.dataItem?.Description
                        : truncateDescription(props.dataItem?.Description),
                  }}
                />
                {props.dataItem?.Description?.length > 100 && (
                  <span
                    className="readmore-btn"
                    style={{
                      textAlign: "right",
                    }}
                    onClick={() =>
                      setExpandedRow(
                        expandedRow === props.dataItem?.ID
                          ? null
                          : props.dataItem?.ID
                      )
                    }
                  >
                    <u>
                      {expandedRow === props.dataItem?.ID
                        ? "Read Less"
                        : "Read More"}
                    </u>
                  </span>
                )}
              </td>
            )}
          />
          <Column field="TestimonialURL" title="Testimonial URL" width={200} />
          <Column
            field="TestimonialImage"
            title="Image"
            width={110}
            filterable={false}
            cell={(props: any) => (
              <td style={{ textAlign: "center" }}>
                <Tooltip
                  title={
                    <img
                      src={props.dataItem?.TestimonialImage}
                      alt="Testimonial Image"
                      width={250}
                      onClick={() =>
                        window.open(props.dataItem?.TestimonialImage)
                      }
                      height={250}
                    />
                  }
                >
                  {props.dataItem?.TestimonialImage ? (
                    <img
                      style={{ border: "1px solid grey", padding: "1px" }}
                      src={props.dataItem?.TestimonialImage}
                      alt="Testimonial Image"
                      width={50}
                      onClick={() =>
                        window.open(props.dataItem?.TestimonialImage)
                      }
                      height={50}
                    />
                  ) : (
                    <>
                      <FaGraduationCap
                        style={{
                          fontSize: "50px",
                          background: "lightgray",
                          padding: "5px",
                          borderRadius: "4px",
                          color: "#163064",
                        }}
                      />
                    </>
                  )}
                </Tooltip>
              </td>
            )}
          />
          <Column
            field="ID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              locked={true}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteTestimonialDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const TestimonialID = useAppSelector(
    (state) => state.testimonial.TestimonialID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteTestimonial(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllTestimonial());
        dispatch(closeDialog());
        dispatch(clearTestimonialID());
      } else {
        dispatch(getAllTestimonial());
        dispatch(closeDialog());
        dispatch(clearTestimonialID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteTestimonial" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Testimonial"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Testimonial ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TestimonialID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Testimonial;
